import { useCallback, useMemo } from 'react';
import { createTeleporter } from 'react-teleporter';
import DashletMenu from '../DashletMenu';
import { useDashletMenu } from './DashletMenuContext';

const DashletMenuController = ({
  dashlet,
  onShowEditModal,
  onEditWithAIHandler,
  onDeleteDashlet,
  onRenameHandler,
  onDuplicateHandler,
  entity,
}) => {
  const DashletMenuContents = useMemo(createTeleporter, []);
  const DashletAction = useMemo(createTeleporter, []);
  const { customMenuItems, canEdit, canModifyDashlet } = useDashletMenu();

  const onDeleteHandler = useCallback(() => {
    return onDeleteDashlet(dashlet.dashboard, dashlet.id);
  }, [dashlet, onDeleteDashlet]);

  return (
    <>
      <DashletAction.Target className="dashlet-action" />
      <DashletMenu
        onDeleteHandler={onDeleteHandler}
        onEditHandler={canModifyDashlet ? onShowEditModal : undefined}
        onEditWithAIHandler={canModifyDashlet ? onEditWithAIHandler : undefined}
        onDuplicateHandler={canModifyDashlet ? onDuplicateHandler : undefined}
        onRenameHandler={canModifyDashlet ? onRenameHandler : undefined}
        customMenuItems={customMenuItems}
        canEdit={canEdit}
        id={dashlet.id}
        entity={entity}
      >
        <DashletMenuContents.Target />
      </DashletMenu>
    </>
  );
};

export default DashletMenuController;
